import { Component, computed, inject } from '@angular/core';
import { IconModule } from '../icons/icon.module';
import { SystemLockService } from '../../../services/system-lock.service';

/**
 * Site-wide banner shown below the header whenever CMT saving is locked — because a publish is running or
 * an operator enabled maintenance mode. Reads the shared {@link SystemLockService} signal (polled app-wide
 * from startup), so it appears on every page and disappears automatically when saving is unlocked.
 */
@Component({
  selector: 'app-system-lock-banner',
  imports: [IconModule],
  templateUrl: './system-lock-banner.component.html',
  styleUrl: './system-lock-banner.component.scss',
})
export class SystemLockBannerComponent {
  protected readonly lock = inject(SystemLockService);

  /** Maintenance mode uses a distinct (non-error) colour to distinguish it from a running publish. */
  protected readonly maintenanceEnabled = computed(() => this.lock.status()?.maintenanceModeEnabled ?? false);
}
